<template>
    <div
        class="dbv"
        :style="{
            maxWidth: width ? `${width}px` : undefined,
            maxHeight: height ? `${height}px` : undefined,
        }"
    >
        <div class="dbv-header" v-if="$slots.header">
            <slot name="header"></slot>
        </div>
        <div class="dbv-body">
            <slot></slot>
        </div>
        <slot name="footer">
            <MagDialogStickyFooter
                :disable-cancel="disableCancel"
                :disable-ok="disableOk"
                @dsf-ok="$emit('dbvOk')"
                @dsf-cancel="$emit('dbvCancel')"
            >
                <template #ok v-if="$slots.ok">
                    <slot name="ok"> </slot>
                </template>
                <template #cancel v-if="$slots.cancel">
                    <slot name="cancel"></slot>
                </template>
            </MagDialogStickyFooter>
        </slot>
    </div>
</template>

<script setup lang="ts">
import MagDialogStickyFooter from "@/components/layout/MagDialogStickyFooter.vue";

defineProps<{
    fullscreen?: boolean;
    width?: number;
    height?: number;
    disableCancel?: boolean;
    disableOk?: boolean;
}>();

defineSlots<{
    header: (props: {}) => any;
    footer: (props: {}) => any;
    cancel: (props: {}) => any;
    ok: (props: {}) => any;
}>();

defineEmits<{
    dbvCancel: [];
    dbvOk: [];
}>();
</script>

<style scoped lang="scss">
.dbv {
    background-color: var(--panel);
    border-radius: var(--radius);
    display: flex;
    flex-direction: column;
    contain: paint;

    > .dbv-header {
        position: sticky;
        top: 0;
        flex-shrink: 0;
        height: 45px;

        align-content: center;
        padding: 0 16px;

        background: var(--windowHeader);
        backdrop-filter: var(--blur, blur(15px));
        border-bottom: 1px solid var(--accentedBg);

        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        pointer-events: none;
    }

    > .dbv-body {
        contain: content;
        overflow: auto;
        flex-grow: 1;
    }
}
</style>
